module.exports = __webpack_public_path__ + "static/media/bees-illustration.95b5f28b.png";